export const NavigateGoToLink = (url) => (window.location.href = url);
